import { MapApi } from 'src/app/hickory-api';

export class MockMapApi extends MapApi { }
